// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react'
import ReactDOM from 'react-dom'
import { createBrowserHistory } from 'history/cjs/history'

import { PublicClientApplication } from '@azure/msal-browser'

import { Provider } from 'react-redux'

import store from './redux/store'
import { MsalProvider } from './@vb/components/Auth/Login/msalContext'
import StylesLoader from './stylesLoader'

import Localization from './localization'
import Router from './router'
import * as serviceWorker from './serviceWorker'
import { msalConfig } from './@vb/components/Auth/Login/auth-config'

// mocking api
import 'services/axios/fakeApi'
// Create MSAL instance using msalConfig from auth-config.js
const msalInstance = new PublicClientApplication(msalConfig)

// middlewared
const history = createBrowserHistory()

ReactDOM.render(
  <Provider store={store}>
    <MsalProvider msalInstance={msalInstance}>
      <StylesLoader>
        <Localization>
          <Router history={history} />
        </Localization>
      </StylesLoader>
    </MsalProvider>
  </Provider>,
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
export { store, history }
